import events from 'reporting-ui-components/events.yaml';
export const EVENTS = Object.keys(events).reduce((map, event) => Object.assign({}, map, {
  [event]: event
}), {});